<template>
    <div>
      <ViewApprovedRequest/>
    </div>
  </template>
  
  <script>
    // @ is an alias to /src
    import ViewApprovedRequest from '@/components/ViewApprovedRequest.vue'
    
    export default {
      name: 'view-approved-request-view',
      components: {
        ViewApprovedRequest
      }
    }
  </script>
  